module.exports = __webpack_public_path__ + "img/bg_room_02.1ab84583.png";